export default {
      id: "TwoFilledArrowRight-usage",
      viewBox: "0 0 8 6",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#TwoFilledArrowRight",
      toString: function () {
        return this.url;
      }
    }